// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

import PhoneNumberData from '../../types/PhoneNumberData';

import { format7 } from '../../constants';

/** Austria */
const AT: PhoneNumberData = [43, 'AT', 13, format7];

export default AT;
